"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.number.constructor");
var _operationsConfig = require("@/api/community/operationsConfig");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'BasicSettings',
  data: function data() {
    return {
      levelOptions: [{
        label: '游客卡',
        value: '0'
      }, {
        label: '普卡',
        value: '1'
      }, {
        label: '银卡',
        value: '2'
      }, {
        label: '金卡',
        value: '3'
      }, {
        label: '黑金卡',
        value: '4'
      }, {
        label: '钻石卡',
        value: '5'
      }],
      levelLimits: [{
        label: '游客卡',
        rank: '0',
        dailyGive: '0',
        dailyReceive: '0'
      }, {
        label: '普卡',
        rank: '1',
        dailyGive: '1',
        dailyReceive: '1'
      }, {
        label: '银卡',
        rank: '2',
        dailyGive: '2',
        dailyReceive: '2'
      }, {
        label: '金卡',
        rank: '3',
        dailyGive: '3',
        dailyReceive: '3'
      }, {
        label: '黑金卡',
        rank: '4',
        dailyGive: '4',
        dailyReceive: '4'
      }, {
        label: '钻石卡',
        rank: '5',
        dailyGive: '5',
        dailyReceive: '5'
      }],
      form: {
        rewardLevelLimit: {
          minGiveLevel: '1',
          minReceiveLevel: '1'
        },
        basicSettings: {
          dailyRewardLimit: 3,
          availableRewardPoints: {
            first: '1',
            second: '3',
            third: '5',
            fourth: '10'
          }
        },
        cardTransferSettings: {
          rules: '',
          usageRules: ''
        },
        profileAndSensitive: {
          changeProfileCost: 50,
          sensitiveWords: ''
        }
      }
    };
  },
  created: function created() {
    this.loadConfig();
  },
  methods: {
    loadConfig: function loadConfig() {
      var _this = this;
      (0, _operationsConfig.getConfigById)(1001).then(function (res) {
        if (res.data && res.data.value) {
          try {
            var c = JSON.parse(res.data.value);
            if (c.can_admire) _this.form.rewardLevelLimit.minGiveLevel = c.can_admire;
            if (c.can_accept) _this.form.rewardLevelLimit.minReceiveLevel = c.can_accept;
            if (c.admire) {
              _this.form.basicSettings.dailyRewardLimit = c.admire.day_num || 3;
              if (c.admire.options) {
                _this.form.basicSettings.availableRewardPoints.first = c.admire.options[0] || '1';
                _this.form.basicSettings.availableRewardPoints.second = c.admire.options[1] || '3';
                _this.form.basicSettings.availableRewardPoints.third = c.admire.options[2] || '5';
                _this.form.basicSettings.availableRewardPoints.fourth = c.admire.options[3] || '10';
              }
            }
            if (c.profile && c.profile.options) {
              _this.form.profileAndSensitive.changeProfileCost = Number(c.profile.options[0]) || 50;
            }
            if (c.words) _this.form.profileAndSensitive.sensitiveWords = c.words;
            if (c.card_rule) _this.form.cardTransferSettings.rules = c.card_rule;
            if (c.card_use_rule) _this.form.cardTransferSettings.usageRules = c.card_use_rule;
            if (c.admire_list) {
              _this.levelLimits.forEach(function (row) {
                if (c.admire_list[row.rank] !== undefined) row.dailyGive = String(c.admire_list[row.rank]);
                if (c.accept_list && c.accept_list[row.rank] !== undefined) row.dailyReceive = String(c.accept_list[row.rank]);
              });
            }
          } catch (e) {/* ignore */}
        }
      });
    },
    handleReset: function handleReset() {
      this.form.rewardLevelLimit.minGiveLevel = '1';
      this.form.rewardLevelLimit.minReceiveLevel = '1';
      this.form.basicSettings.dailyRewardLimit = 3;
      this.form.basicSettings.availableRewardPoints = {
        first: '1',
        second: '3',
        third: '5',
        fourth: '10'
      };
      this.form.cardTransferSettings.rules = '';
      this.form.cardTransferSettings.usageRules = '';
      this.form.profileAndSensitive.changeProfileCost = 50;
      this.form.profileAndSensitive.sensitiveWords = '';
      this.levelLimits = [{
        label: '游客卡',
        rank: '0',
        dailyGive: '0',
        dailyReceive: '0'
      }, {
        label: '普卡',
        rank: '1',
        dailyGive: '1',
        dailyReceive: '1'
      }, {
        label: '银卡',
        rank: '2',
        dailyGive: '2',
        dailyReceive: '2'
      }, {
        label: '金卡',
        rank: '3',
        dailyGive: '3',
        dailyReceive: '3'
      }, {
        label: '黑金卡',
        rank: '4',
        dailyGive: '4',
        dailyReceive: '4'
      }, {
        label: '钻石卡',
        rank: '5',
        dailyGive: '5',
        dailyReceive: '5'
      }];
      this.$message.success('已重置为默认值');
    },
    handleSubmit: function handleSubmit() {
      var _this2 = this;
      var admireList = {};
      var acceptList = {};
      this.levelLimits.forEach(function (row) {
        admireList[row.rank] = row.dailyGive;
        acceptList[row.rank] = row.dailyReceive;
      });
      var payload = {
        can_admire: this.form.rewardLevelLimit.minGiveLevel,
        can_accept: this.form.rewardLevelLimit.minReceiveLevel,
        admire: {
          day_num: this.form.basicSettings.dailyRewardLimit,
          options: [this.form.basicSettings.availableRewardPoints.first, this.form.basicSettings.availableRewardPoints.second, this.form.basicSettings.availableRewardPoints.third, this.form.basicSettings.availableRewardPoints.fourth]
        },
        profile: {
          options: [this.form.profileAndSensitive.changeProfileCost]
        },
        words: this.form.profileAndSensitive.sensitiveWords,
        admire_list: admireList,
        accept_list: acceptList,
        card_rule: this.form.cardTransferSettings.rules,
        card_use_rule: this.form.cardTransferSettings.usageRules
      };
      (0, _operationsConfig.updateConfig)(1001, JSON.stringify(payload)).then(function () {
        _this2.$message.success('设置已保存');
        _this2.loadConfig();
      });
    }
  }
};